class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.config = JSON.parse(this.getAttribute('data-countdown'));

    let year = this.config["year"];
    let month = this.config["month"];
    let day = this.config["day"];
    let hour = this.config["hour"];
    let minute = this.config["minute"];

    // exact format for safari/ios "2018-02-06T20:00:00.000+04:00"
    // https://stackoverflow.com/a/49138448
    const datestring = year+'-'+month+'-'+day+'T'+hour+':'+minute+':00.000'+this.config['timezone'];
    let date = new Date(datestring);  
                   
    this.end_datetime_ms = date.getTime();

    let offset_minutes = new Date(this.end_datetime_ms).getTimezoneOffset();

    // Adjust target time to browsers timezone
    this.end_datetime_ms = this.end_datetime_ms + (60000 * offset_minutes);

    this.countdownEl = this.querySelector('.countdown__times');
    this.dayEl = this.querySelector('.countdown__days');
    this.hoursEl = this.querySelector('.countdown__hours');
    this.minutesEl = this.querySelector('.countdown__minutes');
    this.secondsEl = this.querySelector('.countdown__seconds');
    this.messageEl = this.querySelector('.countdown__text');

    this.startTimer();
  }

  initTimer = (endTime, status, message) => {
    
    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;
  
    const timer = setInterval(() => {
      let now = new Date().getTime();
      let difference = endTime - now;
      if (difference <= 0) {
        clearInterval(timer);
        return this.startTimer();
      } else {
        this.dayEl.innerText = String(Math.floor(difference / days)).padStart(2, '0');
        this.hoursEl.innerText = String(Math.floor( (difference % days) / hours )).padStart(2, '0');
        this.minutesEl.innerText = String(Math.floor( (difference % hours) / minutes )).padStart(2, '0');
        this.secondsEl.innerText = String(Math.floor( (difference % minutes) / seconds )).padStart(2, '0');

        this.countdownEl.classList.remove('hidden');
      }
    }, 1000);
  }

  startTimer = () => {
    const now_ms = new Date().getTime();
    if ( now_ms < this.end_datetime_ms) {
      this.initTimer(this.end_datetime_ms, 'active', "");
    } else {
      this.countdownEl.classList.remove('hidden');
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);